import { useLocation } from 'react-router-dom';

import { getAccessToken, setLocalStorage } from 'services/common/storage';
import { useAppSelector } from 'store/hooks';
import { LOCAL_STORAGE } from 'utils/constants';
import { getLinkLoginSSO, getLinkLogoutSSO } from 'utils/ssoHelper';

const useLoginSSO = () => {
  const token = getAccessToken();
  const { dataSystem } = useAppSelector((state) => state.system);
  const language = useAppSelector((state) => state.system.language);
  const { pathname } = useLocation();

  const hrefLoginSSO = () => {
    localStorage.setItem(LOCAL_STORAGE.CURRENT_PAGE, pathname);
    window.open(getLinkLoginSSO(language, dataSystem?.customerSSOClientId), '_self');
  };

  const hrefLogoutSSO = () => {
    if (token) {
      setLocalStorage(LOCAL_STORAGE.IS_LOGOUT_SSO, 'true');
      window.open(getLinkLogoutSSO(token, window.location.href), '_self');
    }
  };

  const handleCloseOpenSSO = () => {
    localStorage.removeItem(LOCAL_STORAGE.CURRENT_PAGE);
  };

  return { hrefLoginSSO, hrefLogoutSSO, handleCloseOpenSSO };
};

export default useLoginSSO;
